import { MasterTranslation } from '@/constants';
import { useGlobalState, useStatsigLayer } from '@/hooks';

export const useNoParcelsFoundPanelCopy = () => {
  const { t, isLoggedIn } = useGlobalState();
  const { getEnglishOnlyText: getAnonymousEnglishOnlyText, isReady: isAnonymousReady } =
    useStatsigLayer('track_my_parcel_copy_layer');
  const { getEnglishOnlyText: getSignedInEnglishOnlyText, isReady: isSignedInReady } = useStatsigLayer(
    'track_my_parcel_signed_in_layer',
  );

  const fallback = {
    title: t(MasterTranslation.IndividualCardTitle),
    subtitle: t(MasterTranslation.IndividualCardSubtitle),
  };

  if (!isAnonymousReady || !isSignedInReady) return fallback;

  const getEnglishOnlyText = isLoggedIn ? getSignedInEnglishOnlyText : getAnonymousEnglishOnlyText;

  return {
    title: getEnglishOnlyText('individual_card_title', fallback.title),
    subtitle: getEnglishOnlyText('individual_card_subtitle', fallback.subtitle),
  };
};
